import {Pipe} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe {

    private sanitizer: DomSanitizer;
    constructor(sanitizer: DomSanitizer) {
        this.sanitizer = sanitizer;
    }

    transform(style) {
        return this.sanitizer.bypassSecurityTrustStyle(style);
    }

}



// WEBPACK FOOTER //
// C:/Users/muth/Documents/privat/angular/guidr/src/app/pipes/safe.pipe.ts